import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FORCE_PASSWORD_CHANGE_HEADER_NAME, FORCE_PASSWORD_CHANGE_HEADER_VALUE } from '../constants';
import { AuthFacade, AuthRoutes } from '@rx-applications/shared/auth/data-access';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthResponseInterceptor implements HttpInterceptor {
  constructor(private authFacade: AuthFacade, private router: Router) {}
  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    req: HttpRequest<any>,
    next: HttpHandler
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && !this.router.url.includes(AuthRoutes.Verify) && error.status === 401) {
          this.logoutOrForceChangePassword(error);
        }
        return throwError(error);
      })
    );
  }

  private logoutOrForceChangePassword(error: HttpErrorResponse) {
    if (error.headers.get(FORCE_PASSWORD_CHANGE_HEADER_NAME) === FORCE_PASSWORD_CHANGE_HEADER_VALUE) {
      this.authFacade.forceChangePassword();
    } else {
      this.authFacade.logout();
    }
  }
}
